export const galleryData = {
    data() {
        return {
            imageGalleryList: [
            ],
            videoGalleryList: [
                {
                    order: 1,
                    title: "صنایع مبلمان رایزن طوس",
                    description: "",
                    cover: "@/assets/img/test2.png",
                    video: "https://witrino.com/uploads/2022/06/27/16563137582848.mp4",
                    like: 0
                },
            ]
        }
    },

}